(() => {
  function initBulkOrderForms(root = document) {
    root.querySelectorAll('[data-tapn-bulk-order-page]:not([data-tapn-bulk-order-bound])').forEach((page) => {
      page.dataset.tapnBulkOrderBound = 'true';

      const form = page.querySelector('#TapnBulkOrderForm');
      const submit = page.querySelector('[data-tapn-bulk-order-submit]');
      const submitLabel = page.querySelector('[data-tapn-bulk-order-submit-label]');
      const submitIcons = page.querySelectorAll('[data-tapn-bulk-order-submit-icon]');
      if (!form || !submit || !submitLabel || !submitIcons.length) return;

      const quantity = page.querySelector('[data-tapn-bulk-order-quantity]');
      const quantityError = page.querySelector('[data-tapn-bulk-order-quantity-error]');
      const product = page.querySelector('[data-tapn-bulk-order-product]');
      const otherProductField = page.querySelector('[data-tapn-bulk-order-other-product]');
      const otherProductInput = page.querySelector('[data-tapn-bulk-order-other-product-input]');
      const personalisation = page.querySelector('[data-tapn-bulk-order-personalisation]');
      const uploadField = page.querySelector('[data-tapn-bulk-order-upload-field]');
      const uploader = page.querySelector('[data-tapn-file-upload]');
      const fileInput = uploader?.querySelector('[data-tapn-file-upload-input]');
      const fileRemove = uploader?.querySelector('[data-tapn-file-upload-remove]');
      const fileError = uploader?.querySelector('[data-tapn-file-upload-error]');
      const fileErrorMessage = uploader?.querySelector('[data-tapn-file-upload-error-message]');
      const fileTrigger = uploader?.querySelector('[data-tapn-file-upload-trigger]');
      const turnstileContainer = page.querySelector('[data-tapn-turnstile]');
      const turnstileDesktopSlot = page.querySelector('[data-tapn-turnstile-slot="desktop"]');
      const turnstileMobileSlot = form.querySelector('[data-tapn-turnstile-slot="mobile"]');
      const desktopTurnstileMedia = window.matchMedia('(min-width: 64rem)');
      const formError = form.querySelector('[data-tapn-bulk-order-form-error]');
      const formErrorMessage = form.querySelector('[data-tapn-bulk-order-form-error-message]');
      const success = form.querySelector('[data-tapn-bulk-order-success]');
      const minimumQuantity = 10;
      const quantityErrorMessage = `La quantité minimale est de ${minimumQuantity} cartes.`;
      const defaultSubmitLabel = submitLabel.textContent;
      let turnstileWidgetId = null;
      let turnstileAttempts = 0;
      let turnstileToken = '';

      const validateQuantity = () => {
        if (!quantity || !quantityError) return true;

        const rawValue = quantity.value.trim();
        const value = Number(rawValue);
        const isBelowMinimum = rawValue !== '' && Number.isFinite(value) && value < minimumQuantity;

        quantity.setCustomValidity(isBelowMinimum ? quantityErrorMessage : '');
        if (isBelowMinimum) quantity.setAttribute('aria-invalid', 'true');
        else quantity.removeAttribute('aria-invalid');

        quantityError.hidden = !isBelowMinimum;
        return !isBelowMinimum;
      };

      const syncOtherProductField = () => {
        if (!product || !otherProductField || !otherProductInput) return;

        const shouldShowOtherProduct = product.value === 'Autre produit / besoin spécifique';
        otherProductField.hidden = !shouldShowOtherProduct;
        otherProductInput.disabled = !shouldShowOtherProduct;
        otherProductInput.required = shouldShowOtherProduct;

        if (!shouldShowOtherProduct) {
          otherProductInput.setCustomValidity('');
          otherProductInput.removeAttribute('aria-invalid');
        }
      };

      const showFileError = (message) => {
        if (!fileError || !fileErrorMessage || !fileTrigger) return;
        fileErrorMessage.textContent = message;
        fileError.hidden = false;
        fileTrigger.classList.add('is-invalid');
      };

      const clearFileError = () => {
        if (!fileError || !fileErrorMessage || !fileTrigger) return;
        fileErrorMessage.textContent = '';
        fileError.hidden = true;
        fileTrigger.classList.remove('is-invalid');
      };

      const showFormError = (message) => {
        if (!formError || !formErrorMessage) return;
        formErrorMessage.textContent = message;
        formError.hidden = false;
      };

      const clearFormMessages = () => {
        if (formError && formErrorMessage) {
          formErrorMessage.textContent = '';
          formError.hidden = true;
        }
        if (success) success.hidden = true;
      };

      const setSubmitState = (state) => {
        const isLoading = state === 'loading';
        const isSuccess = state === 'success';

        submit.disabled = isLoading || isSuccess;
        submit.classList.toggle('is-success', isSuccess);
        submit.setAttribute('aria-busy', String(isLoading));
        submitLabel.textContent = isLoading ? 'Envoi en cours' : isSuccess ? 'Demande envoyée' : defaultSubmitLabel;
        submitIcons.forEach((icon) => {
          icon.hidden = icon.dataset.tapnBulkOrderSubmitIcon !== state;
        });
      };

      const resetTurnstile = () => {
        turnstileToken = '';
        if (turnstileWidgetId !== null && window.turnstile?.reset) {
          window.turnstile.reset(turnstileWidgetId);
        }
      };

      const syncTurnstilePlacement = () => {
        const targetSlot = desktopTurnstileMedia.matches ? turnstileDesktopSlot : turnstileMobileSlot;
        if (!turnstileContainer || !targetSlot || turnstileContainer.parentElement === targetSlot) return;

        targetSlot.append(turnstileContainer);
        if (turnstileWidgetId !== null) resetTurnstile();
      };

      const renderTurnstile = () => {
        if (!turnstileContainer || turnstileWidgetId !== null) return;

        if (window.turnstile?.render) {
          turnstileWidgetId = window.turnstile.render(turnstileContainer, {
            sitekey: turnstileContainer.dataset.sitekey,
            action: 'bulk_order_submit',
            execution: 'render',
            appearance: 'always',
            language: 'fr',
            theme: 'light',
            size: 'flexible',
            callback: (token) => {
              turnstileToken = token;
            },
            'error-callback': () => {
              showFormError('La vérification de sécurité est indisponible. Réessayez dans quelques instants.');
            },
            'expired-callback': () => {
              turnstileToken = '';
              showFormError('La vérification de sécurité a expiré. Cochez à nouveau la case avant l’envoi.');
            },
          });
          return;
        }

        turnstileAttempts += 1;
        if (turnstileAttempts < 40) window.setTimeout(renderTurnstile, 250);
      };

      const syncPersonalisationField = () => {
        if (!personalisation || !uploadField || !fileInput) return;

        const shouldShowUpload = personalisation.value === 'Avec';
        uploadField.hidden = !shouldShowUpload;
        fileInput.disabled = !shouldShowUpload;

        if (shouldShowUpload) {
          return;
        }

        fileRemove?.click();
        clearFileError();
      };

      const getTurnstileToken = () => {
        return turnstileToken || (turnstileWidgetId !== null && window.turnstile?.getResponse
          ? window.turnstile.getResponse(turnstileWidgetId)
          : turnstileContainer?.querySelector('input[name="cf-turnstile-response"]')?.value || '');
      };

      if (quantity) {
        quantity.addEventListener('input', validateQuantity);
        quantity.addEventListener('blur', validateQuantity);
      }

      form.addEventListener('invalid', (event) => {
        if (event.target === quantity) validateQuantity();
      }, true);

      if (product) product.addEventListener('change', syncOtherProductField);
      syncOtherProductField();

      if (personalisation) personalisation.addEventListener('change', syncPersonalisationField);
      syncPersonalisationField();
      syncTurnstilePlacement();
      renderTurnstile();

      const handleTurnstileBreakpointChange = () => {
        syncTurnstilePlacement();
        renderTurnstile();
      };
      if (desktopTurnstileMedia.addEventListener) desktopTurnstileMedia.addEventListener('change', handleTurnstileBreakpointChange);
      else desktopTurnstileMedia.addListener(handleTurnstileBreakpointChange);

      form.addEventListener('input', () => {
        if (!submit.classList.contains('is-success')) return;
        clearFormMessages();
        setSubmitState('default');
      });

      form.addEventListener('change', () => {
        if (!submit.classList.contains('is-success')) return;
        clearFormMessages();
        setSubmitState('default');
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        validateQuantity();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        clearFileError();
        clearFormMessages();

        const token = getTurnstileToken();
        if (!token) {
          showFormError('Cochez la case de vérification de sécurité avant d’envoyer votre demande.');
          setSubmitState('default');
          turnstileContainer?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        const data = new FormData(form);
        data.set('cf-turnstile-response', token);
        setSubmitState('loading');

        try {
          const response = await fetch(form.dataset.submitEndpoint, { method: 'POST', body: data, credentials: 'omit' });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok || payload.ok !== true) throw new Error(payload.error || 'La demande n’a pas pu être envoyée. Réessayez.');

          form.reset();
          fileRemove?.click();
          syncOtherProductField();
          syncPersonalisationField();
          resetTurnstile();
          setSubmitState('success');
          if (success) {
            success.hidden = false;
            success.scrollIntoView({ block: 'nearest' });
          }
        } catch (error) {
          showFormError(error instanceof Error ? error.message : 'La demande n’a pas pu être envoyée. Réessayez.');
          resetTurnstile();
          setSubmitState('default');
        }
      }, true);

      document.addEventListener('tapn:turnstile-ready', renderTurnstile);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBulkOrderForms());
  else initBulkOrderForms();

  document.addEventListener('shopify:section:load', (event) => initBulkOrderForms(event.target));
})();
